import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { useTranslation } from "react-i18next";
import { RadioGroup } from "components/inputs/radio-group";
import { ToggleCard } from "components/inputs/toggle/Toggle";

export const TimelineVisibilityOptions = ({
    selectedVisibility,
    setSelectedVisibility
}) => {
    const { t } = useTranslation();
    const { privacyOptions } = useSelector(
        (state: RootState) => state.platforms.facebook
    );

    const [selectedId, setSelectedId] = useState(
        selectedVisibility?.value || "EVERYONE"
    );

    const onChange = (newVisibilityValue) => {
        const selectedPrivacy = privacyOptions.find(
            (option) => option.value === newVisibilityValue
        );
        if (selectedPrivacy) {
            setSelectedVisibility(selectedPrivacy);
        }
    };

    const handleCardSelect = (id: string) => {
        setSelectedId(id);
        onChange?.(id);
    };

    const options = [
        {
            id: "EVERYONE",
            name: t("facebook-destination:everyone"),
            description: t("facebook-destination:everyone-description")
        },
        {
            id: "ALL_FRIENDS",
            name: t("facebook-destination:friends"),
            description: t("facebook-destination:friends-description")
        },
        {
            id: "SELF",
            name: t("facebook-destination:only-me"),
            description: t("facebook-destination:only-me-description")
        }
    ];

    return (
        <RadioGroup
            selected={selectedId}
            onChange={handleCardSelect}
            options={options.map((option) => ({
                id: option.id,
                label: (
                    <ToggleCard title={option.name} desc={option.description} />
                )
            }))}
            title={t("facebook-destination:visibility")}
        />
    );
};
